// This function allow to reference async chunks
__webpack_require__.k = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "925d5e7a55981d4b6d14" + ".css";
};